<template>
  <div>
    <v-dialog v-model="dialog" eager persistent scrollable max-width="800">
      <v-form ref="OJTOrgForm" @submit.prevent>
        <v-card class="rounded-lg org-card">
          <v-card-title class="d-flex align-center org-header pa-5">
            <div>
              <div class="text-subtitle-2 text-medium-emphasis">
                Partner Organization
              </div>
              <div class="text-h6 font-weight-bold">
                {{ action }} Partner Organization
              </div>
            </div>
            <v-spacer></v-spacer>
            <v-btn
              icon="mdi-close"
              variant="text"
              density="comfortable"
              @click="closeD()"
            >
            </v-btn>
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text style="max-height: 700px" class="pa-5">
            <v-container class="pa-0">
              <v-row>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="orgID"
                    :rules="[formRules.required]"
                    :items="orgsList"
                    item-value="id"
                    item-title="name"
                    label="Please Select Organization"
                    variant="outlined"
                    density="compact"
                    class="rounded-lg"
                    :color="$vuetify.theme.themes.light.inputColor"
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12" v-if="orgID && orgID != -1">
                  <v-btn
                    :color="$vuetify.theme.themes.light.inputColor"
                    size="small"
                    variant="tonal"
                    class="text-none"
                    prepend-icon="mdi-file-eye-outline"
                    rounded="lg"
                    @click="preview()"
                    >Preview MOA File</v-btn
                  >
                </v-col>

                <template v-if="orgID == -1">
                  <v-col cols="12">
                    <div class="section-divider">
                      <v-icon size="16" color="#10B981" class="mr-1"
                        >mdi-domain</v-icon
                      >
                      <span>Organization Details</span>
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="name"
                      :rules="[formRules.required]"
                      label="Company Name"
                      :color="$vuetify.theme.themes.light.inputColor"
                      variant="outlined"
                      density="compact"
                      class="rounded-lg"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="contact_person"
                      :rules="[formRules.required]"
                      label="Contact Person"
                      :color="$vuetify.theme.themes.light.inputColor"
                      variant="outlined"
                      density="compact"
                      class="rounded-lg"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="email"
                      :rules="[formRules.required, formRules.email]"
                      label="Organization Email"
                      :color="$vuetify.theme.themes.light.inputColor"
                      variant="outlined"
                      density="compact"
                      class="rounded-lg"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="phone_no"
                      :rules="[formRules.required]"
                      label="Phone Number"
                      :color="$vuetify.theme.themes.light.inputColor"
                      variant="outlined"
                      density="compact"
                      class="rounded-lg"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="website"
                      label="Website"
                      :color="$vuetify.theme.themes.light.inputColor"
                      variant="outlined"
                      density="compact"
                      class="rounded-lg"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-textarea
                      v-model="address"
                      :rules="[formRules.required]"
                      label="Office Address"
                      :color="$vuetify.theme.themes.light.inputColor"
                      variant="outlined"
                      density="compact"
                      class="rounded-lg"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      type="number"
                      v-model="allocated_slots"
                      :rules="[formRules.required, formRules.noDecimal]"
                      label="Allocated Slots"
                      :color="$vuetify.theme.themes.light.inputColor"
                      variant="outlined"
                      density="compact"
                      class="rounded-lg"
                    ></v-text-field>
                  </v-col>
                </template>

                <v-col :cols="orgID == -1 ? 6 : 12">
                  <v-autocomplete
                    density="compact"
                    label="Program/s Tied"
                    :rules="[formRules.arrayRequired]"
                    v-model="program_to_tie"
                    item-value="id"
                    item-title="name"
                    :color="$vuetify.theme.themes.light.inputColor"
                    variant="outlined"
                    class="rounded-lg"
                    multiple
                    clearable
                    chips
                    :items="getProgramsHandled"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    density="compact"
                    label="Description"
                    v-model="description"
                    :color="$vuetify.theme.themes.light.inputColor"
                    variant="outlined"
                    class="rounded-lg"
                    rows="3"
                    cols="12"
                  ></v-textarea>
                </v-col>

                <v-col cols="12" v-if="orgID == -1">
                  <div class="section-divider mb-2">
                    <v-icon size="16" color="#10B981" class="mr-1"
                      >mdi-file-document-outline</v-icon
                    >
                    <span>Memorandum of Agreement (MOA)</span>
                  </div>

                  <v-btn
                    v-if="!moa_file && !file_desc && !valid_until"
                    color="#00a63e"
                    class="white--text text-none mb-3"
                    rounded="lg"
                    elevation="0"
                    prepend-icon="mdi-plus"
                    @click="addFileDialog = true"
                    >Add File</v-btn
                  >

                  <v-card
                    flat
                    border
                    class="rounded-lg moa-table-card overflow-hidden"
                  >
                    <v-table density="compact">
                      <thead>
                        <tr>
                          <th class="moa-th text-center">Agreement Type</th>
                          <th class="moa-th text-center">File</th>
                          <th class="moa-th text-center">Description</th>
                          <th class="moa-th text-center">Valid Until</th>
                          <th class="moa-th text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="!moa_file && !file_desc && !valid_until">
                          <td
                            colspan="5"
                            align="center"
                            class="pa-3 text-caption text-grey"
                          >
                            No data found.
                          </td>
                        </tr>
                        <tr v-else>
                          <td align="center" class="pa-2">
                            <v-chip size="small" class="program-chip" label>
                              {{
                                agreement_type == "moa" ? "MOA" : "Agreement"
                              }}
                            </v-chip>
                          </td>
                          <td align="center" class="pa-2 text-body-2">
                            {{
                              moa_file
                                ? moa_file.name
                                  ? moa_file.name
                                  : moa_file
                                : null
                            }}
                          </td>
                          <td align="center" class="pa-2 text-body-2">
                            {{ file_desc }}
                          </td>
                          <td align="center" class="pa-2 text-body-2">
                            {{ formatDate(valid_until) }}
                          </td>
                          <td align="center" class="pa-2">
                            <v-btn
                              color="error"
                              variant="text"
                              size="small"
                              class="text-none"
                              v-bind="props"
                              @click="deleteFile(item)"
                            >
                              <v-icon size="18">mdi-delete-outline </v-icon>
                              Delete
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </v-table>
                  </v-card>

                  <v-dialog
                    v-model="addFileDialog"
                    width="600"
                    transition="dialog-top-transition"
                  >
                    <v-form ref="addFileRef" @submit.prevent>
                      <v-card
                        prepend-icon="mdi-upload"
                        title="Upload File"
                        rounded="lg"
                      >
                        <v-card-text class="">
                          <v-container>
                            <v-row>
                              <v-col cols="12">
                                <v-radio-group
                                  :color="
                                    $vuetify.theme.themes.light.inputColor
                                  "
                                  v-model="agreement_type"
                                  inline
                                >
                                  <v-radio label="MOA" value="moa"></v-radio>
                                  <v-radio
                                    label="Agreement"
                                    value="agreement"
                                  ></v-radio>
                                </v-radio-group>
                              </v-col>
                              <v-col cols="12">
                                <v-file-input
                                  v-model="moa_file"
                                  :rules="[formRules.required]"
                                  variant="outlined"
                                  density="compact"
                                  class="rounded-lg"
                                  accept="application/pdf"
                                  label="File input"
                                ></v-file-input>
                              </v-col>
                              <v-col cols="12">
                                <v-text-field
                                  v-model="file_desc"
                                  :rules="[formRules.required]"
                                  label="Description"
                                  :color="
                                    $vuetify.theme.themes.light.inputColor
                                  "
                                  variant="outlined"
                                  density="compact"
                                  class="rounded-lg"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12">
                                <v-text-field
                                  label="Valid Until Date"
                                  v-model="valid_until"
                                  variant="outlined"
                                  density="compact"
                                  class="rounded-lg"
                                  readonly
                                  :rules="[formRules.required]"
                                  @click="showDatePicker = true"
                                ></v-text-field>

                                <v-dialog
                                  v-model="showDatePicker"
                                  max-width="290"
                                >
                                  <v-date-picker
                                    v-model="valid_until"
                                    @update:model-value="saveDate"
                                    :color="
                                      $vuetify.theme.themes.light.inputColor
                                    "
                                  ></v-date-picker>
                                </v-dialog>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-divider></v-divider>

                        <v-card-actions class="pa-3">
                          <v-spacer></v-spacer>
                          <v-btn
                            color="red-darken-1"
                            variant="outlined"
                            rounded="lg"
                            class="text-none"
                            @click="addFileDialog = false"
                          >
                            <v-icon start>mdi-close-circle-outline</v-icon>
                            Cancel
                          </v-btn>
                          <v-btn
                            color="#00a63e"
                            class="white--text text-none"
                            density="comfortable"
                            variant="flat"
                            rounded="lg"
                            @click="save_file()"
                          >
                            <v-icon start>mdi-check-circle</v-icon>
                            Save
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-form>
                  </v-dialog>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            <v-btn
              density="comfortable"
              variant="outlined"
              rounded="lg"
              class="text-none px-4"
              :disabled="btnLoading"
              :loading="btnLoading"
              @click="closeD()"
            >
              Cancel
            </v-btn>
            <v-btn
              color="#00a63e"
              class="white--text rounded-lg text-none px-4"
              density="comfortable"
              variant="flat"
              elevation="0"
              :disabled="btnLoading"
              :loading="btnLoading"
              @click="save()"
            >
              {{ action == "Add" ? "Add Partner" : "Update Partner" }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import eventBus from "@/eventBus";
export default {
  props: {
    data: Object,
    action: String,
  },
  data() {
    return {
      dialog: false,
      showDatePicker: false,
      addFileDialog: false,
      orgsList: [],
      orgID: null,
      agreement_type: null,
      moa_file: null,
      file_desc: null,
      valid_until: null,
      name: null,
      email: null,
      address: null,
      program_tied_id: null,
      program_to_tie: [],
      btnLoading: false,
      programsList: [],
      deletedFile: null,
      contact_person: null,
      website: null,
      allocated_slots: null,
      phone_no: null,
      description: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
    };
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;

        this.initialize();
        this.$refs.OJTOrgForm.resetValidation();
        if (data.id) {
          this.name = data.name;
          this.email = data.email;
          this.address = data.address;
          this.program_tied_id = data.program_tied;
          this.moa_file = data.moa_file;
          this.file_desc = data.file_desc;
          this.valid_until = data.valid_until;
        } else {
          this.$refs.OJTOrgForm.reset();
        }
      },
      deep: true,
    },
  },
  computed: {
    getProgramsHandled() {
      let arr = [];
      console.log("STOTE", this.$store.state.user.user);
      let handled = this.$store.state.user.user.programs_handled;
      if (this.programsList.length > 0) {
        for (let j = 0; j < handled.length; j++) {
          for (let i = 0; i < this.programsList.length; i++) {
            if (handled[j] == this.programsList[i].id) {
              arr.push(this.programsList[i]);
            }
          }
        }
      }
      return arr;
    },
  },
  methods: {
    initialize() {
      this.getPrograms();
      this.getOrganizations();
    },

    saveDate() {
      if (this.valid_until) {
        this.valid_until = this.formatDate3(this.valid_until);
      }
      this.showDatePicker = false;
    },

    deleteFile() {
      console.log(typeof this.moa_file);
      if (typeof this.moa_file == "string") {
        this.deletedFile = this.moa_file;
      }

      this.moa_file = null;
      this.file_desc = null;
      this.valid_until = null;
    },

    preview() {
      let org = this.orgsList.find((item) => this.orgID == item.org_id);
      console.log(org);
      let url =
        process.env.VUE_APP_SERVER +
        "/organization-program-agreement/getFile/" +
        org.filename;
      let token = localStorage.getItem("token");
      const tab = window.open("about:blank");
      fetch(url, { headers: { Authorization: `Bearer ${token}` } })
        .then((response) => response.blob())
        .then((blob) => {
          var _url = window.URL.createObjectURL(blob);
          tab.location = _url;
          tab.focus();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async save() {
      let formValid = await this.$refs.OJTOrgForm.validate();

      if (formValid.valid) {
        if (this.orgID == -1) {
          if (this.file_desc && this.valid_until && this.moa_file) {
            this.btnLoading = true;
            let data = {
              id: this.data.id,
              name: this.name,
              address: this.address,
              email: this.email,
              contact_person: this.contact_person,
              phone_no: this.phone_no,
              website: this.website,
              allocated_slots: this.allocated_slots,
              description: this.description,
              program_tied_id: JSON.stringify(this.program_to_tie),
              file_desc: this.file_desc,
              valid_until: this.valid_until,
              deletedFile: this.deletedFile,
              agreement_type: this.agreement_type,
            };
            let fd = new FormData();
            fd.append("data", JSON.stringify(data));
            fd.append("file", this.moa_file);
            this.axiosCall("/organization", "POST", fd).then((res) => {
              if (res.data.status == 201) {
                this.fadeAwayMessage.show = true;
                this.fadeAwayMessage.type = "success";
                this.fadeAwayMessage.message = res.data.msg;
                this.fadeAwayMessage.header = "System Message";
                this.btnLoading = false;
                this.closeD();
              } else {
                this.btnLoading = false;
                this.fadeAwayMessage.show = true;
                this.fadeAwayMessage.type = "error";
                this.fadeAwayMessage.message = res.data.msg;
                this.fadeAwayMessage.header = "System Message";
              }
            });
          } else {
            this.btnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.message = "File Attachment is required!";
            this.fadeAwayMessage.header = "System Message";
          }
        } else {
          this.axiosCall("/organization/addProgramTied", "PATCH", {
            orgID: this.orgID,
            program_id: JSON.stringify(this.program_to_tie),
          }).then((res) => {
            if (res.data.status == 200) {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.message = res.data.msg;
              this.fadeAwayMessage.header = "System Message";
              this.btnLoading = false;
              this.closeD();
            } else {
              this.btnLoading = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.message = res.data.msg;
              this.fadeAwayMessage.header = "System Message";
            }
          });
        }
      }
    },

    async save_file() {
      let valid = await this.$refs.addFileRef.validate();
      if (valid.valid) {
        this.addFileDialog = false;
      }
    },

    UpdateInfo() {
      let data = {
        fname: this.fname,
        mname: this.mname,
        lname: this.lname,
      };
      this.axiosCall(
        "/user-details/updateUserInfo/" +
          this.data.id +
          "/" +
          JSON.stringify(data),
        "POST",
        data,
      ).then((res) => {
        if (res.data.status == 200) {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.message = res.data.message;
          this.fadeAwayMessage.header = "System Message";
          this.closeD();
          this.refresh();
        } else {
          this.isLoading = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.message = res.data.message;
          this.fadeAwayMessage.header = "System Message";
          this.animated = true;
        }
      });
    },
    closeD() {
      eventBus.emit("closeOJTOrgsDialog", true);
      this.dialog = false;
    },

    getPrograms() {
      this.axiosCall("/program", "GET").then((res) => {
        this.programsList = res.data;
      });
    },

    getOrganizations() {
      this.axiosCall(
        "/organization/selection/" + this.$store.state.user.program_id,
        "GET",
      ).then((res) => {
        this.orgsList = res.data;
        this.orgsList.push({ id: -1, name: "Add New Organization/Agency" });
      });
    },
  },
};
</script>

<style scoped>
.tbl {
  width: 100%;
  border-collapse: collapse;
}

.org-card {
  overflow: hidden;
}

.org-header {
  background-color: #fafafa;
}

.section-divider {
  display: flex;
  align-items: center;
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  color: #4b5563;
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 8px;
}

.moa-table-card {
  border-color: #e5e7eb !important;
}

.moa-th {
  background-color: #10b981;
  color: #ffffff;
  font-weight: 600;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  padding: 10px 8px;
}

.program-chip {
  background-color: #eef2ff;
  color: #4338ca;
  font-weight: 600;
  border-radius: 6px;
}
</style>
